import * as React from 'react';
import type { SVGProps } from 'react';
const SvgHighlighter = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 18 16"
    {...props}
  >
    <path
      fill="#787887"
      d="m.5 15 2.125-2.187 2.094 2.093L3.594 16zM16.969 2.5c.656.625.687 1.656.093 2.344L10 13.125c-.187.219-.594.375-.875.375-.094 0-.25 0-.344-.031l-1.312-.406-1.063 1.062c-.312.281-.781.281-1.062 0l-1.938-1.969c-.312-.281-.312-.75 0-1.062L4.47 10.03 4.062 8.72A1.3 1.3 0 0 1 4 8.375c0-.281.156-.687.375-.875L12.656.438C13 .156 13.406 0 13.781 0c.469 0 .906.188 1.219.531zM9 11.969l1.031-1.219L6.75 7.469 5.563 8.5l.312 1.094.281.875-.625.625-.531.531.875.906.531-.531.625-.656.875.281zm6.906-8.094c.094-.125.094-.25.031-.312l-2-1.97c-.03-.062-.093-.062-.156-.062-.031 0-.094 0-.125.032L7.5 6.813 10.688 10z"
    />
  </svg>
);
export default SvgHighlighter;
